import axios from '@/axios'
import { METHODS } from '@/enum'
import type { UserInfo, CertInfo, studentInfo } from '@/types/response'

const enum APIS {
  USER_INFO = '/userapi/api/v2.1/users/me/info',
  GIFT_INFO = '/order/api/v2.1/gift/eligibility',
  OBTATN = '/order/api/v2.1/gift/obtain',
  EFFECT = '/order/api/v2.1/gift/effect',
  CERT_PERSONAL = '/api/v1/certify/personal',
  CERT_ENTERPRISE = '/api/v1/certify/enterprise',
  CERT_PERSONAL_CONFIRM = '/api/v1/certify/personal/confirm',
  UPLOAD_ENTERPRISE = '/api/v1/certify/enterprise/upload',
  CERT_ENTERPRISE_CONFIRM = '/api/v1/certify/enterprise/confirm',
  CERT_INFO = '/api/v1/certify/info',
  UPLOAD_AVATAR = `/api/v1/users/me/logo`,
  USER_PASSWORD = `/api/v1/users/me/password`,
  USER_MOBILE = `/userapi/api/v2.1/users/me/mobile`,
  USER_EMAIL = `/userapi/api/v2.1/users/me/email`,
  GET_CAPTCHA = `/api/v1/users/verify/smscode`,
  CHECK_REPEAT = `/userapi/api/v2.1/register/validate`,
  // 学生会员认证
  STUDENT_CHECK = '/userapi/api/v3/student_verification',
  STUDENT_EMAIL = '/userapi/api/v3/student_verification/emailcode',
  STUDENT_IMAGE = '/userapi/api/v3/student_verification/image',
}

// 获取学生会员信息
export async function getStudentInfo() {
  return axios.request<studentInfo>({
    url: APIS.STUDENT_CHECK,
    method: METHODS.GET,
  })
}

// 学生邮箱验证码
export async function getStudentCode(data: { email: string }) {
  return axios.request<{
    certificationId: string
    qrCode: string
  }>({
    url: APIS.STUDENT_EMAIL,
    method: METHODS.POST,
    data,
  })
}

// 学生认证
export async function certStudent(data: studentInfo) {
  return axios.request<{
    certificationId: string
    qrCode: string
  }>({
    url: APIS.STUDENT_CHECK,
    method: METHODS.POST,
    data,
  })
}
// 获取用户信息
export async function userinfo() {
  return axios.request<UserInfo>({
    url: APIS.USER_INFO,
    method: METHODS.GET,
  })
}
// 获取gpu优惠券信息
export async function requestGift() {
  return axios.request<UserInfo>({
    url: APIS.GIFT_INFO,
    method: METHODS.GET,
  })
}

// 领取gpu优惠券
export async function requestObtain(isRenew: boolean, giftId?: number) {
  const url = isRenew ? APIS.EFFECT + '/' + giftId : APIS.OBTATN
  return axios.request<UserInfo>({
    url: url,
    method: METHODS.POST,
  })
}

// 获取认证信息
export async function certInfo() {
  return axios.request<CertInfo>({
    url: APIS.CERT_INFO,
    method: METHODS.GET,
  })
}

// 个人认证
export type CertPersonalProps = { certName: string; certNo: string }
export async function certPersonal(data: CertPersonalProps) {
  return axios.request<{
    certificationId: string
    qrCode: string
  }>({
    url: APIS.CERT_PERSONAL,
    method: METHODS.POST,
    data,
  })
}

// 阿里认证
export type ResponseConfirm = { status: 'Passed' | 'Unknown' | 'Failed' }
export async function certPersonalConfirm(data: { certificationId: string }) {
  return axios.request<ResponseConfirm>({
    url: APIS.CERT_PERSONAL_CONFIRM,
    method: METHODS.POST,
    data,
  })
}

export async function certEnterpriseConfirm(data: { certificationId: string }) {
  return axios.request<ResponseConfirm>({
    url: APIS.CERT_ENTERPRISE_CONFIRM,
    method: METHODS.POST,
    data,
  })
}

export async function uploadEnterprise(data: FormData) {
  return axios.request<{ path: string }>({
    url: APIS.UPLOAD_ENTERPRISE,
    method: METHODS.PUT,
    data,
  })
}
export async function uploadIdCard(data: FormData) {
  return axios.request<{ image: string }>({
    url: APIS.STUDENT_IMAGE,
    method: METHODS.PUT,
    data,
  })
}

export type CertEnterPriseProps = {
  companyName: string
  organizationNo: string
  license: string
}

export async function certEnterPrise(data: CertEnterPriseProps) {
  return axios.request<{
    certificationId: string
    qrCode: string
    skip: boolean
  }>({
    url: APIS.CERT_ENTERPRISE,
    method: METHODS.POST,
    data,
  })
}

// 上传用户头像
export async function uploadAvatar(data: FormData) {
  return axios.request<{ path: string }>({
    url: APIS.UPLOAD_AVATAR,
    method: METHODS.PUT,
    data,
  })
}

// 修改密码
export type UserPassword = {
  oldPassword: string
  newPassword: string
}
export async function updatePassword(data: UserPassword) {
  return axios.request<{ path: string }>({
    url: APIS.USER_PASSWORD,
    method: METHODS.PUT,
    data,
  })
}

// 修改绑定手机
export type UserMobile = {
  mobile: string
  password: string
  captcha: string
}
export async function updateMobile(data: UserMobile) {
  return axios.request<{ path: string }>({
    url: APIS.USER_MOBILE,
    method: METHODS.PUT,
    data,
  })
}

// 修改绑定邮箱
export type UserEmail = {
  email: string
  password: string
}
export async function updateEmail(data: UserEmail) {
  return axios.request<{ path: string }>({
    url: APIS.USER_EMAIL,
    method: METHODS.PUT,
    data,
  })
}
// 获取验证码
export async function getCaptcha(data: { mobile: string }) {
  return axios.request<{ path: string }>({
    url: APIS.GET_CAPTCHA,
    method: METHODS.POST,
    data,
  })
}
// 查询手机号是否被注册
export type CheckType = {
  kind: 'name' | 'email' | 'mobile'
  value: string
}
export async function checkRepeat(data: CheckType) {
  return axios.request<{ path: string }>({
    url: APIS.CHECK_REPEAT,
    method: METHODS.POST,
    data,
  })
}
